module.exports = __webpack_public_path__ + "img/symbol_3.d1b7fae5.png";